export const POLICYHOLDER_MIN_AGE = 18;
